import React from "react";
import { PictureOutlined, FilePdfOutlined, FileOutlined, MinusCircleOutlined } from "@ant-design/icons";

export const fixedDocTitles = [
    "TDS",
    "COA",
    "SDS",
    "包装照",
    "产品照",
];

export function truncateTitle(title) {
    if (!title) return "";
    return title.length > 8 ? `${title.slice(0, 5)}…` : title;
}

export function getDocTypeInfo(doc) {
    const href = doc && doc.uri;
    const type = doc && doc.type;
    if (!href) {
        return {
            kind: "empty",
            icon: <MinusCircleOutlined />,
        };
    }
    if (type === 1) {
        return {
            kind: "image",
            icon: <PictureOutlined />,
        };
    }
    if (type === 2) {
        return {
            kind: "pdf",
            icon: <FilePdfOutlined />,
        };
    }
    return {
        kind: "other",
        icon: <FileOutlined />,
    };
}

export function buildDownloadUrl(uri, name) {
    if (!uri) {
        return uri;
    }
    if (uri.indexOf("attname=") !== -1) {
        return uri;
    }
    
    let fileName = name || "";
    // Check if name already has an extension
    const nameHasExt = /\.[a-zA-Z0-9]+$/.test(fileName);
    
    if (!nameHasExt) {
        // Try to extract extension from URI (ignoring query params)
        const urlPath = uri.split('?')[0];
        const match = urlPath.match(/\.([a-zA-Z0-9]+)$/);
        if (match) {
            fileName += `.${match[1]}`;
        }
    }

    const hasQuery = uri.indexOf("?") !== -1;
    const sep = hasQuery ? "&" : "?";
    const encoded = encodeURIComponent(fileName);
    return `${uri}${sep}attname=${encoded}`;
}

export function buildDocGroups(docs) {
    const source = Array.isArray(docs) ? docs.slice() : [];
    const remaining = source.slice();
    const regularDocs = fixedDocTitles.map((title) => {
        const lower = title.toLowerCase();
        const idx = remaining.findIndex((item) => {
            const t = (item.title || "").trim().toLowerCase();
            return t === lower;
        });
        if (idx === -1) {
            return {
                key: title,
                title,
                uri: null,
            };
        }
        const doc = remaining[idx];
        remaining.splice(idx, 1);
        return {
            key: doc.document_id || doc.id || `${doc.grade_id}-${doc.uri}`,
            ...doc,
            title,
        };
    });
    const otherDocs = remaining.map((item) => ({
        key: item.document_id || item.id || `${item.grade_id}-${item.uri}`,
        ...item,
    }));
    return {
        regularDocs,
        otherDocs,
    };
}
